import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useHead } from '@unhead/vue'

import ErrorContent from '@/components_new/ErrorContent/ErrorContent.vue'
import { useLocalizedRouters } from '@/composables/localized-routers'
import { ROUTE_NAMES } from '@/router/constants'
import { type ErrorStatus } from '@/store/app-store'


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  props: {
    type: {}
  },
  setup(__props: any) {



const { getHrefLangs } = useLocalizedRouters()

useHead(() => ({
    link: getHrefLangs({ forRoute: { name: ROUTE_NAMES.MAIN } }),
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ErrorContent, {
    type: _ctx.type,
    showButtons: ""
  }, null, 8, ["type"]))
}
}

})